
<script>
import PieChart from "../reporting/pieChart.vue";


export default {

  components: { PieChart},

  props: {

    ageRangeRate: {
        type: Object,
        default: () => null
        }
    },

 
};
</script>

<template>

    <div class="h-100" v-if="ageRangeRate && ageRangeRate.values && ageRangeRate.labels ">
        <PieChart :data="ageRangeRate.values" :labels="ageRangeRate.labels"  />
    </div>

</template>
